import { proxy } from 'valtio';

import type { TeamInfo } from 'models';

const state = proxy<{
    teams: TeamInfo[];
}>({
    teams: [],
});

export { state };
